var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayLargeMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play_large_mobile_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h88v88H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play_large_mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.053 57.75l17.875-11.458c.855-.55 1.283-1.314 1.283-2.291 0-.978-.428-1.742-1.283-2.292L39.053 30.251c-.917-.611-1.849-.657-2.796-.138-.947.52-1.421 1.33-1.421 2.43v22.916c0 1.1.474 1.91 1.42 2.43.948.519 1.88.473 2.797-.138zm4.95 22.917c-5.073 0-9.84-.962-14.3-2.887-4.462-1.925-8.342-4.538-11.642-7.838-3.3-3.3-5.913-7.18-7.838-11.641-1.925-4.462-2.887-9.228-2.887-14.3 0-5.073.962-9.84 2.887-14.3 1.925-4.462 4.538-8.342 7.838-11.642 3.3-3.3 7.18-5.913 11.642-7.838 4.46-1.925 9.227-2.887 14.3-2.887 5.072 0 9.839.962 14.3 2.888 4.46 1.925 8.341 4.537 11.641 7.837 3.3 3.3 5.913 7.18 7.838 11.642 1.925 4.46 2.887 9.227 2.887 14.3 0 5.072-.962 9.839-2.887 14.3-1.925 4.46-4.538 8.341-7.838 11.641-3.3 3.3-7.18 5.913-11.641 7.838-4.461 1.925-9.228 2.887-14.3 2.887zm0-7.333c8.188 0 15.125-2.842 20.808-8.525s8.525-12.62 8.525-20.808c0-8.19-2.842-15.125-8.525-20.809-5.683-5.683-12.62-8.525-20.808-8.525-8.19 0-15.125 2.842-20.809 8.525-5.683 5.684-8.525 12.62-8.525 20.809 0 8.189 2.842 15.125 8.525 20.808 5.684 5.683 12.62 8.525 20.809 8.525z",
    fill: "#fff"
  }))));
}
export default SvgPlayLargeMobile;